module.exports = __webpack_public_path__ + "static/media/icon-docs.bb7284b2.svg";